var map = {
	"./Duplo Chocnut T1 26g.jpg": 11374,
	"./Duplo T2 2Riegel 18,2g.jpeg": 30352,
	"./Duplo WhiteT10.jpg": 19058,
	"./Duplo Wihte Single 18,2g.jpg": 32448,
	"./FERRERO COLLECTION 172g.jpeg": 38670,
	"./FERRERO COLLECTION 269g.jpg": 99598,
	"./FERRERO RAFFAELLO 150g.jpg": 44599,
	"./FERRERO RAFFAELLO 230g.jpg": 42702,
	"./FERRERO ROCHER 100g T8.jpg": 68075,
	"./FERRERO ROCHER DIAMANTE  T24 300g.jpg": 4978,
	"./HARIBO 175g BARBECUE.jpeg": 37277,
	"./HARIBO 175g COLA-LEMON.jpg": 33496,
	"./HARIBO 175g Fantasia.jpg": 87418,
	"./HARIBO 175g Golden - Juice.jpg": 31376,
	"./HARIBO 175g Golden.jpeg": 51977,
	"./HARIBO 175g HAPPY COLA.jpeg": 58056,
	"./HARIBO 175g JELLY BEANS.jpg": 55864,
	"./HARIBO 175g MLECZNE MISIE.jpeg": 96995,
	"./HARIBO 175g Mallow Mania.jpeg": 14920,
	"./HARIBO 175g Miami.jpeg": 60571,
	"./HARIBO 175g Wummis jellies.jpg": 20564,
	"./Halls 33,5g COOLWAVE.jpeg": 58014,
	"./Halls 33,5g EXTRA STRONG.jpg": 16985,
	"./Halls 33,5g FOREST FRUIT.jpg": 58999,
	"./Halls 33,5g HONEY&LEMON.jpg": 95097,
	"./Halls 33,5g LIME FRESH.png": 96136,
	"./Halls 33,5g MILD SPERMINT.jpg": 45487,
	"./Halls FRUITWAVE 45g PEACH.jpeg": 86829,
	"./Halls FRUITWAVE 45g STRAWBERRY.jpg": 57094,
	"./KINDER BUENO 43g.jpg": 35411,
	"./KINDER BUENO WHITE 39g.png": 10,
	"./KINDER COUNTRY 24g T1.jpg": 9057,
	"./KINDER Chocolate 50G T4.jpg": 24749,
	"./KINDER DELICE 39g KAKAO.png": 69829,
	"./KINDER SURPRISE 20g.jpg": 48737,
	"./Kinder Joy.jpg": 40247,
	"./KitKat Salted cream popcorn 42g.jpg": 32919,
	"./Kitkat 4 finger 41,5g.jpeg": 90416,
	"./Kitkat Peanut butter 42g.jpg": 98952,
	"./Kitkat chunky milk 40g.jpg": 43249,
	"./Kitkat dark 70 percent 41,5g.jpeg": 78065,
	"./M&M's Choco 45g.jpg": 21603,
	"./M&M's Chocolate 90g.jpg": 84652,
	"./M&M's Dark Chocolate 47,9g.jpg": 4345,
	"./M&M's Peanut Butter 90,7g.jpg": 1207,
	"./M&M’S CHOCOLATE 100G.png": 54811,
	"./M&M’S PEANUT 100G.jpg": 90271,
	"./M&M’s Chocolate 150g.jpg": 10102,
	"./M&M’s Peanut 150g.jpeg": 52762,
	"./MALTESERS Chocolate Drops 37g.jpg": 22376,
	"./MARS 51g.jpg": 63033,
	"./MILKY WAY 21,5g.jpg": 48608,
	"./MILKY WAY DUO 2PAK 43g.jpg": 23313,
	"./Mentos Fruit 37,5g.jpg": 71334,
	"./Mentos Gum Bottle Peppermint 45’s 70g.png": 35784,
	"./Mentos Mint dragees 38g.jpg": 73031,
	"./Mentos Strong Mint 37,5g.jpg": 24038,
	"./Merci 400g.jpg": 85070,
	"./Milka Cookies Choco Grains 126g.jpg": 25335,
	"./Milka Cookies Choco Mousse 128g.jpeg": 15934,
	"./Milka Cookies Choco Sticks 112g.jpg": 72835,
	"./Milka Cookies ChocoMoo 120g.jpg": 16278,
	"./Milka Cookies Chocolate 135g.jpg": 64085,
	"./Milka Cookies Nuts 135g.jpg": 77331,
	"./Milka Cookies Orange Jelly 147g.jpg": 62298,
	"./Milka Cookies Raisin 135g.jpg": 21522,
	"./Milka Cookies Raspberry Jelly 147g.jpg": 57978,
	"./Milka Extra Cocoa 100 g.jpeg": 18625,
	"./Milka Hazelnuts 100g.png": 23725,
	"./Milka Noisette 100g.jpeg": 33482,
	"./Milka OREO 100 g.jpg": 87195,
	"./Milka Raisins & Hazelnuts 100g.jpg": 14011,
	"./Milka Strawberry & Yoghurt 100g.jpg": 89107,
	"./Milka White FP 100g.jpg": 721,
	"./NUTELLA B-READY 22g.jpg": 58976,
	"./NUTELLA B-READY 44g.jpg": 46599,
	"./Nestle lion blond 40g.jpg": 17625,
	"./Nestle lion chocolate 42g.png": 51130,
	"./Nestle lion coconut 40g.jpg": 55285,
	"./Nestle lion peanut 41g.png": 3281,
	"./Nestle lion white 42g.jpg": 30363,
	"./Nestle lion wild peanut 30g.jpg": 75351,
	"./Nutella & go 52g.jpg": 43916,
	"./Nutella 1000g.jpeg": 26424,
	"./Nutella 15g.jpg": 61078,
	"./Nutella 230g.jpg": 27079,
	"./Nutella 25g.jpeg": 45395,
	"./Nutella 3000g.jpg": 20427,
	"./Nutella 350g.jpeg": 88212,
	"./Nutella 400g.jpg": 71841,
	"./Nutella 600g+50g.jpg": 51342,
	"./Nutella 600g.jpeg": 71006,
	"./Nutella 630g.jpg": 59889,
	"./Nutella 750g+75g.jpg": 57472,
	"./Nutella 750g.jpg": 16336,
	"./Orbit 10pcs Bubblemint 14g.jpg": 90189,
	"./Orbit 10pcs Peppermint 14g.jpg": 93893,
	"./Orbit 10pcs Spearmint 14g.jpg": 83361,
	"./Orbit 10pcs Strawberry 14g.jpg": 48713,
	"./Oreo Choco Brownie 176g.jpg": 22186,
	"./Oreo Double Cream 170g.jpg": 99777,
	"./Oreo Golden 176g.jpg": 11127,
	"./Oreo Original 176g.jpg": 21730,
	"./PRINCE POLO XXL 50g Classic.jpg": 54272,
	"./PRINCE POLO XXL 50g Coconut.jpeg": 42670,
	"./PRINCE POLO XXL 50g Milk.jpeg": 36665,
	"./PRINCE POLO XXL 50g nuts.jpg": 18928,
	"./Prince Polo Black XXL 50g.jpeg": 26733,
	"./SNICKERS 50g.jpg": 25115,
	"./TIC TAC 18g Mint.png": 93888,
	"./TIC TAC 18g Orange.jpg": 74800,
	"./TIC TAC 18g Strawberry.jpg": 60841,
	"./TWIX 50g.jpg": 41858,
	"./TWIX XTRA 75g.jpg": 27851,
	"./Toffifee 125 g.jpeg": 29193,
	"./Twix 42,5g original.jpg": 13440,
	"./kitkat chunky white 40g.jpg": 52681,
	"./m&m's mega chocolate 270g.jpg": 22899,
	"./m&m's peanut 45g.jpg": 65284,
	"./m&m's peanut 90g.jpg": 68796,
	"./merci 250g.jpeg": 1333,
	"./milka milk 100g.jpg": 47955,
	"./milka milkinis 100g.png": 47175,
	"./toblerone  100g Dark Chocolate.jpg": 72148,
	"./toblerone  100g White Chocolate.jpg": 47695,
	"./toblerone milk chocolate 100g.jpg": 22539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7790;